import { Component, Input } from '@angular/core';
import { CoreMenuItem } from '@core/types';


declare let window: any;

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
}
